import ParamBanque from "@/components/parametres/parametre/param-banque";

export default {
    name: 'parametre',
    components: {
        ParamBanque
    },
    props: [],
    data() {
        return {
            config_to_show: 'banque'
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        changeTab(tab_to_show) {
            this.config_to_show = tab_to_show
        },
    }
}